/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Shuffled_WrongInputs */



/**
* | output |
* | --- |
* | "Someone shuffled the code wrong." |
*
* @param {Error_Subtext_Shuffled_WrongInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_shuffled_wrong = /** @type {((inputs?: Error_Subtext_Shuffled_WrongInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Shuffled_WrongInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jemand hat den Code falsch gemischt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelqu'un a mal mélangé le code.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("有人把代码洗乱了。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("有人把程式碼洗錯順序了。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("누군가 코드를 잘못 섞었습니다.")
	return /** @type {LocalizedString} */ ("Someone shuffled the code wrong.")
});